export default "__VITE_ASSET__DhPrOnk4__"